<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div [ngClass]="this.isSmallScreen ? 'entry-4-modal' : 'entry-5-modal'">
            <label>{{'usuarios.etiquetador.modal.username' | translate}} *</label>
            <input id="userName" type="email" autocomplete="off" formControlName="userName">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-4-modal' : 'entry-5-modal'" *ngIf="!etiquetadorId && showPassword">
            <label>{{'usuarios.etiquetador.modal.password' | translate}} *</label>
            <input type="text" formControlName="password">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-4-modal' : 'entry-5-modal'">
            <label>{{'usuarios.etiquetador.modal.etiquetador' | translate}} *</label>
            <app-filterable-list [itemsList]="etiquetadores" [selectedItem]="newEditForm.get('etiquetador')" [placeHolder]="false">
            </app-filterable-list>
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-4-modal' : 'entry-5-modal'">
            <label>{{'usuarios.etiquetador.modal.nombre' | translate}} *</label>
            <input type="text" formControlName="nombre">
        </div>
        <div [ngClass]="this.isSmallScreen ? 'entry-4-modal' : 'entry-5-modal'">
            <label>{{'usuarios.etiquetador.modal.apellido' | translate}} *</label>
            <input type="text" formControlName="apellido">
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.etiquetador.modal.zonaHoraria' | translate}} *</label>
            <app-filterable-list [ngClass]="role === 'Etiquetador' ? 'shorter-list' : 'short-list'" [itemsList]="timezones" [selectedItem]="newEditForm.get('msTimeZone')" [placeHolder]="false" [disabled]="disabledTimezone"></app-filterable-list>
        </div>
        <div class="entry-4-modal" *ngIf="!etiquetadorId">
            <label>{{'usuarios.etiquetador.modal.direccion' | translate}} </label>
            <input type="text" formControlName="direccion">
        </div>
        <div class="entry-4-modal" *ngIf="!etiquetadorId">
            <label>{{'usuarios.etiquetador.modal.telefono' | translate}}</label>
            <input type="text" formControlName="phoneNumber">
        </div>
        <div class="entry-4-modal">
            <label>{{'usuarios.etiquetador.modal.idioma' | translate}} *</label>
            <app-filterable-list class="shorter-list" [itemsList]="idiomas" [selectedItem]="newEditForm.get('idioma')" [placeHolder]="false" [disabled]="disabledIdioma"></app-filterable-list>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
            <input type="checkbox" id="useTwoFactor" formControlName="useTwoFactor">
            <label for="useTwoFactor">{{'usuarios.etiquetador.modal.dobleFactor' | translate}}</label>
        </div>
        <div class="entry-4-modal alignment-start" *ngIf="this.role === 'Administrador'">
            <input type="checkbox" id="activo" formControlName="activo">
            <label for="activo">{{'usuarios.etiquetador.modal.activo' | translate}}</label>
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{etiquetadorId ? ('global.actualizar' | translate ) : ('global.insertar' | translate )}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event"></app-toast>
<div class="modal" *ngIf="showModal">
    <div class="modal-content">
      <header>
        <h4>{{'usuarios.modalRegistro.header' | translate}}</h4>
      </header>
      <content>
        <p>{{'usuarios.modalRegistro.content' | translate}}</p>
      </content>
      <footer>
        <button class="secondary" (click)="hideModal()">{{ 'global.aceptar' | translate }}</button>
      </footer>
    </div>
</div>
  